// Lib
import { FC, useRef } from "react";
// Theme
import { theme } from "theme";
// Icons
import { FileUploadIcon } from "icons";
// Styled
import { Button } from "styled/Buttons";

interface UploadCsvInputButtonProps {
  title: string;
  isLoading?: boolean;
  disabled?: boolean;
  upload: (formData: FormData) => Promise<void>;
}

export const UploadCsvInputButton: FC<UploadCsvInputButtonProps> = ({
  title,
  isLoading,
  disabled,
  upload,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleButtonClick = () => {
    inputRef.current?.click();
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.name.endsWith(".csv")) {
      console.log("Only CSV files allowed");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      await upload(formData);

      console.log("File uploaded");
    } catch (error) {
      console.error("Upload error", error);
    } finally {
      e.target.value = "";
    }
  };

  return (
    <>
      <Button.Base
        icon={
          <FileUploadIcon
            fill={
              disabled ? theme.color.text.disabled : theme.color.text.primary2
            }
          />
        }
        loading={isLoading}
        disabled={disabled}
        onClick={handleButtonClick}
      >
        {title}
      </Button.Base>

      <input
        ref={inputRef}
        type="file"
        accept=".csv,text/csv"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </>
  );
};
